export const SUBDOMAIN = process.env.REACT_APP_SUBDOMAIN as string;
export const SUBDOMAIN_ANALYTICS = process.env
  .REACT_APP_ANALYTICS_SUBDOMAIN as string;
